export default __webpack_public_path__ + "static/media/abstrakt.9f10bfc8.png";